import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _18f6a67f = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _4bd5daae = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _956d46e6 = () => interopDefault(import('../../../pages/centro-integrado-de-saude.vue' /* webpackChunkName: "pages/centro-integrado-de-saude" */))
const _8ec3fa24 = () => interopDefault(import('../../../pages/consultoria.vue' /* webpackChunkName: "pages/consultoria" */))
const _199ef03a = () => interopDefault(import('../../../pages/cursos/index.vue' /* webpackChunkName: "pages/cursos/index" */))
const _534e48ee = () => interopDefault(import('../../../pages/extensao-digital/index.vue' /* webpackChunkName: "pages/extensao-digital/index" */))
const _54c252be = () => interopDefault(import('../../../pages/graduacao.vue' /* webpackChunkName: "pages/graduacao" */))
const _c4298768 = () => interopDefault(import('../../../pages/graduacao-digital/index.vue' /* webpackChunkName: "pages/graduacao-digital/index" */))
const _aaefaf68 = () => interopDefault(import('../../../pages/graduacao-presencial/index.vue' /* webpackChunkName: "pages/graduacao-presencial/index" */))
const _ef2321b0 = () => interopDefault(import('../../../pages/home.vue' /* webpackChunkName: "pages/home" */))
const _46b4f157 = () => interopDefault(import('../../../pages/hub-de-inovacao.vue' /* webpackChunkName: "pages/hub-de-inovacao" */))
const _32772c53 = () => interopDefault(import('../../../pages/hub-e21.vue' /* webpackChunkName: "pages/hub-e21" */))
const _09d7e896 = () => interopDefault(import('../../../pages/hub-e21/index.vue' /* webpackChunkName: "pages/hub-e21/index" */))
const _d9675700 = () => interopDefault(import('../../../pages/hub-e21/servicos.vue' /* webpackChunkName: "pages/hub-e21/servicos" */))
const _1e7fe1db = () => interopDefault(import('../../../pages/institucional.vue' /* webpackChunkName: "pages/institucional" */))
const _76d28880 = () => interopDefault(import('../../../pages/marcas.vue' /* webpackChunkName: "pages/marcas" */))
const _1b1368f6 = () => interopDefault(import('../../../pages/metodologia.vue' /* webpackChunkName: "pages/metodologia" */))
const _b590dc38 = () => interopDefault(import('../../../pages/portal-de-turismo-e-hotelaria/index.vue' /* webpackChunkName: "pages/portal-de-turismo-e-hotelaria/index" */))
const _65c8db70 = () => interopDefault(import('../../../pages/pos-graduacao/index.vue' /* webpackChunkName: "pages/pos-graduacao/index" */))
const _15d3b68a = () => interopDefault(import('../../../pages/blog/categoria/_slug.vue' /* webpackChunkName: "pages/blog/categoria/_slug" */))
const _4a1f3966 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _1d0c32ca = () => interopDefault(import('../../../pages/cursos/_slug.vue' /* webpackChunkName: "pages/cursos/_slug" */))
const _5197a7a6 = () => interopDefault(import('../../../pages/extensao-digital/_slug.vue' /* webpackChunkName: "pages/extensao-digital/_slug" */))
const _ae5cf1f8 = () => interopDefault(import('../../../pages/graduacao-presencial/_slug.vue' /* webpackChunkName: "pages/graduacao-presencial/_slug" */))
const _69361e00 = () => interopDefault(import('../../../pages/pos-graduacao/_slug.vue' /* webpackChunkName: "pages/pos-graduacao/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _18f6a67f,
    name: "404"
  }, {
    path: "/blog",
    component: _4bd5daae,
    name: "blog"
  }, {
    path: "/centro-integrado-de-saude",
    component: _956d46e6,
    name: "centro-integrado-de-saude"
  }, {
    path: "/consultoria",
    component: _8ec3fa24,
    name: "consultoria"
  }, {
    path: "/cursos",
    component: _199ef03a,
    name: "cursos"
  }, {
    path: "/extensao-digital",
    component: _534e48ee,
    name: "extensao-digital"
  }, {
    path: "/graduacao",
    component: _54c252be,
    name: "graduacao"
  }, {
    path: "/graduacao-digital",
    component: _c4298768,
    name: "graduacao-digital"
  }, {
    path: "/graduacao-presencial",
    component: _aaefaf68,
    name: "graduacao-presencial"
  }, {
    path: "/home",
    component: _ef2321b0,
    name: "home"
  }, {
    path: "/hub-de-inovacao",
    component: _46b4f157,
    name: "hub-de-inovacao"
  }, {
    path: "/hub-e21",
    component: _32772c53,
    children: [{
      path: "",
      component: _09d7e896,
      name: "hub-e21"
    }, {
      path: "servicos",
      component: _d9675700,
      name: "hub-e21-servicos"
    }]
  }, {
    path: "/institucional",
    component: _1e7fe1db,
    name: "institucional"
  }, {
    path: "/marcas",
    component: _76d28880,
    name: "marcas"
  }, {
    path: "/metodologia",
    component: _1b1368f6,
    name: "metodologia"
  }, {
    path: "/portal-de-turismo-e-hotelaria",
    component: _b590dc38,
    name: "portal-de-turismo-e-hotelaria"
  }, {
    path: "/pos-graduacao",
    component: _65c8db70,
    name: "pos-graduacao"
  }, {
    path: "/blog/categoria/:slug?",
    component: _15d3b68a,
    name: "blog-categoria-slug"
  }, {
    path: "/blog/:slug",
    component: _4a1f3966,
    name: "blog-slug"
  }, {
    path: "/cursos/:slug",
    component: _1d0c32ca,
    name: "cursos-slug"
  }, {
    path: "/extensao-digital/:slug?",
    component: _5197a7a6,
    name: "extensao-digital-slug"
  }, {
    path: "/graduacao-presencial/:slug?",
    component: _ae5cf1f8,
    name: "graduacao-presencial-slug"
  }, {
    path: "/pos-graduacao/:slug?",
    component: _69361e00,
    name: "pos-graduacao-slug"
  }, {
    path: "/",
    redirect: "/home/"
  }, {
    path: "/blog-multiversa",
    redirect: "/blog"
  }, {
    path: "/quem-somos",
    redirect: "/institucional"
  }, {
    path: "/blog-multiversa/:slug",
    redirect: "/blog/:slug"
  }, {
    path: "/faculdade-multiversa/:slug",
    redirect: "/:slug"
  }, {
    path: "/faculdade-multiversa",
    redirect: "/"
  }, {
    path: "/faculdade-multiversa/*/:slug",
    redirect: "/*/:slug"
  }, {
    path: "/mba-gestao",
    redirect: "/pos-graduacao/mba-em-gestao-universitaria"
  }, {
    path: "/hube21",
    redirect: "/hub-e21"
  }, {
    path: "/hub-e21/editais",
    redirect: "/hub-e21#editais"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
